(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luminoire-customer-stories"] && !Shopify.designMode) return;
  try {
    
if (!window.luminoireCommunityEditorReady) {
  window.luminoireCommunityEditorReady = true;
  document.addEventListener('shopify:block:select', event => {
    const card = event.target.closest('.lcs__card');
    if (!card) return;
    const rail = card.closest('.lcs__grid');
    if (rail.scrollWidth > rail.clientWidth) rail.scrollTo({left:card.offsetLeft - rail.offsetLeft - 20, behavior:'smooth'});
  });
}

  } catch(e) { console.error(e); }
})();
})();
